import { rootApi } from 'src/services/rootApi';
import { HTTPRequestType } from 'src/services/api.types';

/** The System Dashboard AI layer switch (JT1-1820). Mirrors `AiLayerSwitchService` in the backend. */

export interface AiCoverage {
  total: number;
  /** null when the AI search engine could not be reached. */
  indexed: number | null;
}

export interface AiLayerStatus {
  organizationId: string;
  enabled: boolean;
  coverage: { candidates: AiCoverage; contacts: AiCoverage; companies: AiCoverage };
  changes: { enabled: boolean; at: string; by: string | null }[];
}

export const aiLayerApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAiLayerStatus: builder.query<AiLayerStatus, string>({
      query: (organizationId) => ({ url: `/system/organizations/${organizationId}/ai-layer` }),
      providesTags: (_result, _error, organizationId) => [{ type: 'AiLayer', id: organizationId }],
    }),

    setAiLayer: builder.mutation<AiLayerStatus, { organizationId: string; enabled: boolean }>({
      query: ({ organizationId, enabled }) => ({
        url: `/system/organizations/${organizationId}/ai-layer`,
        method: HTTPRequestType.PUT,
        data: { enabled },
      }),
      invalidatesTags: (_result, _error, { organizationId }) => [{ type: 'AiLayer', id: organizationId }],
    }),

    indexAiLayer: builder.mutation<{ queued: boolean }, string>({
      query: (organizationId) => ({ url: `/system/organizations/${organizationId}/ai-layer/index`, method: HTTPRequestType.POST }),
    }),
  }),
});

export const { useGetAiLayerStatusQuery, useSetAiLayerMutation, useIndexAiLayerMutation } = aiLayerApi;
